import React, { useState } from 'react';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
const faqs = [{
  q: '¿En qué año de la carrera me conviene comprarlo?',
  a: 'En cualquiera. Está pensado desde 2do año (cuando arrancan las materias clínicas) hasta el recién egresado. Cuanto antes lo uses, más te ahorra dolores de cabeza.'
}, {
  q: 'No tengo plata ahora, ¿conviene esperar?',
  a: 'La oferta de hoy (con los 6 bonos incluidos gratis) es por tiempo limitado. Mañana el pack vuelve a su precio normal de $52.690 y los bonos dejan de estar incluidos.'
}, {
  q: '¿Es solo teoría o puedo aplicarlo de verdad en la clínica?',
  a: 'Es lo opuesto a la facultad. Cada capítulo está enfocado en la clínica real: protocolos, tablas, checklists y casos. Las plantillas las podés usar literalmente al día siguiente.'
}, {
  q: '¿Sirve si todavía no entré a la rotación clínica?',
  a: 'Sí. Justamente está pensado para que llegues a la rotación con criterio, no con miedo. Los capítulos 1, 2 y 4 son fundamentales antes de pisar la clínica.'
}, {
  q: '¿Cómo lo recibo después de pagar?',
  a: 'Apenas confirmes tu pago te llega a tu email un link de descarga inmediata con todos los PDFs (6 módulos + 6 bonos). Es 100% digital, no se envía nada físico.'
}, {
  q: '¿Puedo abrirlo en celular, tablet y compu?',
  a: 'Sí. Son PDFs optimizados para verlos en cualquier dispositivo y también podés imprimirlos. Muchos estudiantes los usan en el celular durante la guardia.'
}, {
  q: '¿Está actualizado a Argentina/Latinoamérica?',
  a: 'Sí. Incluye enfermedades prevalentes acá (Chagas, Leishmaniasis, Ehrlichia, Parvovirus) y consideraciones específicas de la práctica veterinaria en la región.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenemos garantía de satisfacción. Si después de revisar el material sentís que no era para vos, escribinos al soporte y resolvemos.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 bg-gradient-to-b from-sky-50/40 to-white" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <div className="text-center mb-10" data-id="element-74">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-100 text-green-800 font-bold text-sm mb-4" data-id="element-75">
            <HelpCircleIcon className="w-4 h-4" data-id="element-76" /> PREGUNTAS FRECUENTES
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-77">
            Tus dudas, respondidas
          </h2>
        </div>

        <div className="space-y-3" data-id="element-78">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={i} className={`rounded-xl border-2 transition-all overflow-hidden ${isOpen ? 'border-green-400 bg-white shadow-md' : 'border-slate-200 bg-white'}`} data-id="element-79">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-80">
                  <span className="font-bold text-slate-900 text-sm sm:text-base" data-id="element-81">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-green-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-82" />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-83">
                  <div className="overflow-hidden" data-id="element-84">
                    <p className="px-5 pb-5 text-slate-600 text-sm sm:text-base leading-relaxed" data-id="element-85">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-10" data-id="element-86">
          <BuyButton label="QUIERO ACCEDER AHORA" data-id="element-87" />
        </div>
      </div>
    </section>;
}